import React, { Component, Fragment } from "react";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../config/images/gambar';
import { getSemester, getUser } from "../../../services/api-services/krs-api";
import { getPresensi } from "../../../services/api-services/presensi-api";

class Presensi extends Component {
    state = {
        user: [],
        listSemester: [],
        listPresensi: [],
        isLoading: false
    }
    getAllData = async () => {
        const allPromise = Promise.all([
            getUser(localStorage.getItem('nim')),
            getSemester(localStorage.getItem('nim'))
        ])
        const promises = await allPromise
        this.setState({
            user: promises[0].data,
            listSemester: promises[1].data
        })
    }
    inputSemester = async (e) => {
        const datas = {
            nim: localStorage.getItem('nim'),
            semester: e.target.value,
            kurikulum: this.state.user.kurikulum
        }
        this.setState({ isLoading: true })
        const res = await getPresensi(datas)
        if (res) { this.setState({ listPresensi: res.data.data, isLoading: false }) }
    }

    // handle to print 
    print = (prodi, type) => {
        const doc = new jsPDF();

        var imageAsia = Image.data

        doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19)

        var width = doc.internal.pageSize.getWidth()
        doc.setFont("Times-bold", "bold")
        doc.setFontSize(11.5);
        doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

        let fakultas
        if (prodi == "Teknik Informatika" || prodi == "Sistem Komputer" || prodi == "Desain Komunikasi Visual") {
            fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN"
        } else if (prodi == "Akuntansi" || prodi == "Manajemen") {
            fakultas = "FAKULTAS EKONOMI DAN BISNIS"
        }

        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);
        doc.text(fakultas, width / 2, 36.5, { align: 'center' });

        doc.setFont("Times-Roman", "normal");
        doc.setFontSize(11.5);
        doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 41.5, { align: 'center' });

        doc.setLineWidth(0.1)
        doc.line(10, 47, 200, 47)

        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);

        doc.text("KARTU " + type, width / 2, 56, { align: 'center' });

        doc.autoTable({
            html: '#headerTabel',
            startY: doc.lastAutoTable + 63,
            theme: 'plain',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                fontSize: '10.5',
                cellPadding: 1
            },
            margin: { left: 10, right: 10 }
        });

        doc.autoTable({
            html: '#printJadwal',
            theme: 'grid',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                valign: 'middle',
            },
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 'black',
                valign: 'middle',
                halign: 'center',
                lineWidth: 0.1
            },
            columnStyles: {
                0: { halign: 'center' },
                1: { halign: 'center' },
                4: { halign: 'center' },
                5: { cellWidth: 30, minCellHeight: 15 },
            },
            margin: { top: 10, left: 10, right: 10, bottom: 10 },
        });

        window.open(doc.output('bloburl'), '_blank')
    }

    componentDidMount = () => {
        this.getAllData()
    };
    render() {
        return (
            <div>
                <Fragment>
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p
                                    className="abu"
                                    style={{
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                        color: "#999999",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data
                                    Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp; Presensi
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row" id="smoothMain">
                        <div className="col-xl-12" id="kontenKiri">
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                        Presensi
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{this.state.user.nama}</td>

                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>
                                                        <select className="form-control" name="semester" onChange={this.inputSemester}>
                                                            <option value="">- Pilih Semester -</option>
                                                            {this.state.listSemester.map((v, index) => {
                                                                return (
                                                                    <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                                )
                                                            })
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <br />
                                    <p className="card-title" style={{ fontSize: "17px", marginLeft: "10px" }}>
                                        Laporan Presensi Mahasiswa :
                                    </p>
                                    {this.state.isLoading ?
                                        <div id="loaderMhs">
                                            <div className="loader-1 colorful mt-5 mb-2">
                                                <div className="dot" />
                                                <div className="dot" />
                                                <div className="dot" />
                                            </div>
                                            <p align="center" className="mb-5">loading data...</p>
                                        </div>
                                        :
                                        <div>
                                            <div className="table-responsive pl-2 pr-2 mt-3">
                                                <table className="table-bordered" style={{ width: "100%" }}>
                                                    <tbody>
                                                        <tr className='customTable'>
                                                            <td width="50px" rowSpan={2} align='center'>
                                                                No
                                                            </td>
                                                            <td width="120px" rowSpan={2} align='center'>
                                                                Kode MK
                                                            </td>
                                                            <td width="300px" rowSpan={2} align='center'>
                                                                MK
                                                            </td>
                                                            <td width="50px" rowSpan={2} align='center'>
                                                                SKS
                                                            </td>
                                                            <td width="300px" rowSpan={2} align='center'>
                                                                Dosen
                                                            </td>
                                                            <td height="40px" width="300px" colSpan={5} align='center'>
                                                                Keterangan
                                                            </td>
                                                        </tr>
                                                        <tr className='customTable'>
                                                            <td width="60px" align="center">
                                                                Hadir
                                                            </td>
                                                            <td height="40px" width="60px" align="center">
                                                                Alpa
                                                            </td>
                                                            <td height="40px" width="60px" align="center">
                                                                Sakit
                                                            </td>
                                                            <td height="40px" width="60px" align="center">
                                                                Ijin
                                                            </td>
                                                            <td height="40px" width="60px" align="center">
                                                                Total
                                                            </td>
                                                        </tr>
                                                        {this.state.listPresensi.length == 0 ?
                                                            <tr>
                                                                <td colSpan={10} style={{ padding: '20px', textAlign: 'center' }}>Tidak Ada Data.</td>
                                                            </tr>
                                                            :
                                                            <Fragment>
                                                                {this.state.listPresensi.map((list, i) => {
                                                                    return (
                                                                        <tr className='customTable2' key={i}>
                                                                            <td height="40px" width="60px" align="center">{i + 1}</td>
                                                                            <td height="40px" width="60px" align="center">{list.kodemk}</td>
                                                                            <td height="40px" width="60px" align="center">{list.matakuliah}</td>
                                                                            <td height="40px" width="60px" align="center">{list.sks}</td>
                                                                            <td height="40px" width="60px" align="center">{list.dosen}</td>
                                                                            <td height="40px" width="60px" align="center">{list.hadir}</td>
                                                                            <td height="40px" width="60px" align="center">{list.alpa}</td>
                                                                            <td height="40px" width="60px" align="center">{list.sakit}</td>
                                                                            <td height="40px" width="60px" align="center">{list.ijin}</td>
                                                                            <td height="40px" width="60px" align="center">{list.total_pertemuan}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                            </Fragment>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* {
                                                this.state.listPresensi.length != 0 ?
                                                    <>
                                                        <br />
                                                        <div className="dropdown mb-1" style={{ float: 'right' }}>
                                                            <button className="btn btn-success dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i className="fa fa-print"></i>&nbsp;Cetak Kartu .PDF
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                <a className="dropdown-item" href="#" onClick={() => this.print(this.state.user.jurusan, "UJIAN TENGAH SEMESTER")}><i className="fa fa-print"></i>&nbsp;&nbsp;Kartu UTS</a>
                                                                <a className="dropdown-item" href="#" onClick={() => this.print(this.state.user.jurusan, "UJIAN AKHIR SEMESTER")}><i className="fa fa-print"></i>&nbsp;&nbsp;Kartu UAS</a>
                                                            </div>
                                                        </div>
                                                    </> : null
                                            } */}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment >

                {/* print area  */}
                <div style={{ display: 'none' }}>
                    <table id="headerTabel">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td>Nama</td>
                                <td> : </td>
                                <td>{this.state.user.nama}</td>

                                <td>Semester</td>
                                <td> : </td>
                                <td>{this.state.user.semester}</td>
                            </tr>
                            <tr>
                                <td>NIM</td>
                                <td> : </td>
                                <td>{this.state.user.nim}</td>

                                <td>Tahun Akademik</td>
                                <td> : </td>
                                <td>{this.state.user.ta}</td>
                            </tr>
                            <tr>
                                <td>Program Studi</td>
                                <td> : </td>
                                <td>
                                    {this.state.user.jurusan}
                                </td>

                                <td>Wali</td>
                                <td> : </td>
                                <td>{this.state.user.dosenwali}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table id="printJadwal">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Kode MK</th>
                                <th>Mata Kuliah</th>
                                <th>Dosen</th>
                                <th>Kelas</th>
                                <th>TTD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.listPresensi.map((list, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{list.kodemk}</td>
                                        <td>{list.matakuliah}</td>
                                        <td>{list.dosen}</td>
                                        <td>{list.kodekelas}</td>
                                        <td></td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {/* end of print area  */}
            </div >
        );
    }
}

export default Presensi;
